var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B9CAC",
    fillRule: "evenodd",
    d: "M17.233 9.167c-5.467 0-9.9 4.432-9.9 9.9 0 5.259 4.102 9.561 9.28 9.88.967.06 1.72.862 1.72 1.83v1.73l3.347-3.06c.337-.309.779-.48 1.237-.48h3.85c5.467 0 9.9-4.433 9.9-9.9 0-5.468-4.433-9.9-9.9-9.9h-9.534Zm-13.566 9.9C3.667 11.574 9.74 5.5 17.233 5.5h9.534c7.492 0 13.566 6.074 13.566 13.567 0 7.492-6.074 13.566-13.566 13.566h-3.139l-5.89 5.387a1.833 1.833 0 0 1-3.071-1.353V32.39c-6.266-1.2-11-6.709-11-13.324Zm9.166-2.567c0-1.012.821-1.833 1.834-1.833h9.166a1.833 1.833 0 0 1 0 3.666h-9.166a1.833 1.833 0 0 1-1.834-1.833Zm1.834 3.667a1.833 1.833 0 0 0 0 3.666h14.666a1.833 1.833 0 0 0 0-3.666H14.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgComments;